import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ShelfApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.SHELF);
  }
}

export default new ShelfApi();
